import { Maybe } from '@iss/libs/graphql';

export const findPreferred = <T>(
  items: readonly T[],
  preferred: T | null = null,
): T | null =>
  items.length === 1 ? items[0] : items.find((item) => item === preferred) || null;

export const nullIfEmpty = <T = unknown>(arr: Maybe<readonly T[]>): readonly T[] | null =>
  arr?.length ? arr : null;
